module.exports = __webpack_public_path__ + "static/media/lostandfound.0aebb575.webp";